import { DataNotFoundImage } from 'assets'
import { VideoCard } from 'components'
import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setAllVideoDataAction } from 'store/action/videoReducer'

function YoutubeShort({ onRestEmpty, isEmpty }) {
   const dispatch = useDispatch()
   const { videoList, loading, isFetchVideo, allVideoData } = useSelector(
      (state) => state.videoRedux
   )

   // ✅ Ref to track latest allVideoData without triggering re-renders
   const videoDataRef = useRef(allVideoData)

   // Sync ref with latest redux state
   useEffect(() => {
      videoDataRef.current = allVideoData
   }, [allVideoData])

   // Reset Redux allVideoData if parent triggers empty
   useEffect(() => {
      if (isEmpty) {
         dispatch(setAllVideoDataAction([]))
         onRestEmpty()
      }
   }, [isEmpty])

   // Reset Redux allVideoData when fetch starts
   useEffect(() => {
      if (isFetchVideo) {
         dispatch(setAllVideoDataAction([]))
      }
   }, [isFetchVideo])

   // ✅ Append new data to Redux state without duplicates
   useEffect(() => {
      if (Array.isArray(videoList) && videoList.length && !loading) {
         const newItems = videoList.filter(
            (newItem) => !videoDataRef.current.some((item) => item.video_id === newItem.video_id)
         )

         if (newItems.length) {
            const updatedData = [...videoDataRef.current, ...newItems]
            videoDataRef.current = updatedData
            dispatch(setAllVideoDataAction(updatedData))
         }
      }
   }, [videoList])

   return (
      <div className="row">
         {allVideoData && allVideoData.length > 0
            ? allVideoData.map((item, i) => (
                 <div className="col-12 col-lg-4 mt-3" key={item.video_id || i}>
                    <VideoCard items={item} />
                 </div>
              ))
            : !loading && (
                 <div className="not-found-section">
                    <img
                       src={DataNotFoundImage}
                       alt="No Videos Found"
                       className="not-found-image"
                    />
                    <p>Oops! Short list not found.</p>
                 </div>
              )}
      </div>
   )
}

export default YoutubeShort
